import { Box, IconButton } from "@material-ui/core"
import { LinksType } from "common/SiteLinks"
import NextLink from "components/Reusable/Bit/NextLink"
import styled from "styled-components"

const StyledFooterSocialLink = styled(Box)<{ $rightMargin?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: "center";
  ${(p) => !p?.$rightMargin && "margin-right: auto;"}
  gap: 16px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin: 0px;
    justify-content: space-evenly;
    width: 100%;
  }
  a {
    display: flex;
    ${(p) => p.theme.breakpoints.down("sm")} {
      margin-right: 0px;
    }
  }
`

const StyledIconButton = styled(IconButton)<{ href?: string; target?: string }>`
  padding: 0;
  svg {
    width: 22px;
    height: 22px;
  }
`

type FooterLinkListProps = {
  linkList: LinksType[]
  rightMargin?: boolean
}

const FooterSocialLinksList = ({
  linkList,
  rightMargin,
}: FooterLinkListProps) => {
  return (
    <StyledFooterSocialLink $rightMargin={rightMargin}>
      {linkList.map((item, index) => (
        <NextLink href={item.link} key={index} passHref>
          <StyledIconButton
            href=""
            target="_blank"
            aria-label={`ה${item.hebrewTitle} של מקדונלד'ס`}
          >
            {item?.iconComp}
          </StyledIconButton>
        </NextLink>
      ))}
    </StyledFooterSocialLink>
  )
}

export default FooterSocialLinksList
